import React, { useRef, useState, useCallback } from 'react'
import useSliderMethods from '../../Hooks/useSliderMethods'
import { Transition } from 'react-transition-group'
import { Link } from 'react-router-dom'
import Loader from '../../Components/Loader'
import BackgroundImage from '../../wp-adons/BackgroundImage'
import PreviousButton from '../../PageComponents/PreviousButton'
import NextButton from '../../PageComponents/NextButton'
import DownButton from '../../PageComponents/DownButton'
import { setMargin, setPadding } from '../../utilities'
export default function GalleryFromPost ({
  jsonResponse,
  margin_selection,
  padding_selection
}) {
  const pageStyles = {
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  const nodeRef = useRef(null)
  const [showDescription, setShowDescription] = useState(-1)
  const { setTimer, removeTimer, previousImage, nextImage, currentSlide } =
    useSliderMethods({
      loopTime: 10000,
      loop: jsonResponse
    })
  const showDescriptionBtnOnClick = useCallback(
    index => {
      if (showDescription === index) {
        setShowDescription(-1)
      } else {
        setShowDescription(index)
      }
    },
    [showDescription]
  )
  const tailwindPadding =
    margin_selection?.padding_select === 'site padding' ? 'py-24' : 'py-0'
  const tailwindMargin =
    margin_selection?.margin_select === 'site margin' ? 'my-24' : 'my-auto'
  return jsonResponse ? (
    <div
      style={{ ...pageStyles }}
      className={`flex flex-col w-full mx-auto h-svh max-h-svh items-center justify-center relative overflow-hidden ${tailwindPadding} ${tailwindMargin}`}
      onMouseEnter={removeTimer}
      onMouseLeave={setTimer}
    >
      <PreviousButton onClick={previousImage} />

      {jsonResponse?.map((post, index) => (
        <Transition
          in={index === currentSlide}
          nodeRef={nodeRef}
          timeout={1000}
          key={index}
        >
          {state => (
            <div
              className={`gallery gallery-${state} w-full flex flex-col h-full absolute overflow-hidden justify-center items-center gap-6`}
              ref={nodeRef}
            >
              {post?.acf?.background_image && (
                <BackgroundImage
                  background_image={post.acf?.background_image}
                />
              )}
            </div>
          )}
        </Transition>
      ))}
      {jsonResponse?.map((post, index) => (
        <Transition
          in={index === currentSlide}
          nodeRef={nodeRef}
          timeout={1000}
          key={index}
        >
          {state => (
            <div
              className={`slider slider-${state} w-full flex flex-col h-full absolute overflow-hidden justify-center items-center gap-6`}
              ref={nodeRef}
            >
              {post?.acf?.sub_title && (
                <p className='text-header4 relative z-10 text-white text-center font-text_accent mb-4 uppercase'>
                  {post?.acf?.sub_title}
                </p>
              )}
              {post?.title?.rendered && (
                <p className='text-header1 relative z-10 text-white text-center font-text_highlight mb-4 uppercase'>
                  {post?.title?.rendered}
                </p>
              )}
              {post?.acf?.cta && (
                <Link
                  to={post?.acf?.cta}
                  className='text-header5 relative z-10 text-white border-solid border-white border-2 text-center font-text_readable mb-4 rounded-full p-2 px-5'
                >
                  Discover More
                </Link>
              )}
              {post?.acf?.description && (
                <div
                  className={`mx-auto mt-4 z-10 transition-all duration-500 relative${
                    showDescription === index
                      ? 'opacity-0 pointer-events-none'
                      : 'opacity-100 pointer-events-auto'
                  }`}
                >
                  <DownButton
                    onClick={() => showDescriptionBtnOnClick(index)}
                  />
                </div>
              )}
              {post?.acf?.description && (
                <div
                  className={`w-full h-full absolute transition-all duration-500 flex flex-col items-center justify-center z-20 ${
                    showDescription === index
                      ? 'top-0 z-20 backdrop-blur-sm  opacity-100 pointer-events-auto'
                      : 'top-full z-0 opacity-0 pointer-events-none'
                  }`}
                >
                  {post?.title?.rendered && (
                    <p className='text-header1 relative z-10 text-white text-center font-text_highlight mb-4 uppercase'>
                      {post?.title?.rendered}
                    </p>
                  )}
                  <div
                    className={`text-header4 transition-all text-white text-center font-text_readable max-w-sitemax p-4 relative z-10`}
                    dangerouslySetInnerHTML={{ __html: post?.acf?.description }}
                  />
                  <div
                    className={`mx-auto mt-12 z-30 transition-all duration-500 relative`}
                  >
                    <DownButton
                      onClick={() => showDescriptionBtnOnClick(index)}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </Transition>
      ))}
      <NextButton onClick={nextImage} />
    </div>
  ) : (
    <Loader />
  )
}
